import i18next from 'i18next';

i18next.addResources('en', 'AdelphiStep', {
  continue: 'Continue',
  goBack: 'Go back',
  confirm: 'Confirm',
  saveAndExit: 'Save and exit'
});
